<template>
  <div class="host">
    <div class="vm-table-wrap">
      <table class="vm-table sticky">
        <thead>
          <slot name="header" />
        </thead>
        <tbody>
          <slot name="body" />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sticky: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.vm-table-wrap {
  width: 100%;
  overflow: auto;
}
.vm-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}
.vm-table.sticky {
  border-collapse: separate;
}
.vm-table.sticky th {
  top: 0px;
  position: sticky;
  background-color: white;
}
.vm-table thead tr {
  height: 56px;
  color: rgba(0, 0, 0, 0.52);
  background-color: white;
}
.vm-table tbody tr {
  height: 48px;
  color: rgba(0, 0, 0, 0.81);
}
.vm-table th,
.vm-table td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.vm-table th {
  font-size: 12px;
  font-weight: 500;
}
.vm-table td {
  font-size: 14px;
}
.vm-table th:first-child,
.vm-table td:first-child {
  padding-left: 24px;
}
.vm-table th:last-child,
.vm-table td:last-child {
  padding-right: 24px;
}
</style>
